var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.407014 0 0.909091 0H19.0909C19.593 0 20 0.447715 20 1C20 1.55228 19.593 2 19.0909 2H0.909091C0.407014 2 0 1.55228 0 1ZM0 7C0 6.44772 0.407014 6 0.909091 6H19.0909C19.593 6 20 6.44772 20 7C20 7.55228 19.593 8 19.0909 8H0.909091C0.407014 8 0 7.55228 0 7ZM0.909091 12C0.407014 12 0 12.4477 0 13C0 13.5523 0.407014 14 0.909091 14H19.0909C19.593 14 20 13.5523 20 13C20 12.4477 19.593 12 19.0909 12H0.909091Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.09f797d61d219da3cb48d7112b87d4bf.svg";
export { ForwardRef as ReactComponent };